import {
    ColoursObj,
    drawerStore,
    Icon,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { TeamMember } from '../../../home/overlay/TeamMember'
import { MemberProfilePic } from '../../../home/team/MemberProfilePic'
import { useBoundStore } from '../../../state/bound.store'
import { safeSignalSet } from '../../../utils'
import { NavigationView } from '../../layout/NavigationView'
import { useRocketChatContext } from '../rocketChatProvider'
import { useChatBodyContext } from './chatProvider'

export const ChatUserList = () => {
    const { api, members } = useChatBodyContext()
    const { chatView } = useRocketChatContext()
    const { setOverride } = useBoundStore(
        useShallow((s) => {
            return {
                setOverride: s.setOverride,
            }
        })
    )

    const returnMembersList = useCallback(
        function () {
            if (members?.value) {
                return members.value.map((member, index) => {
                    return member.name === 'soft' ? (
                        <div key={index} />
                    ) : (
                        <Stack
                            key={index}
                            width={'100%'}
                            direction={'row'}
                            justifyContent={'space-between'}
                            padding={'16px'}
                            boxSizing={'border-box'}
                            style={{ borderBottom: '1px solid #F5F9FA' }}
                            onClick={() => {
                                if (
                                    member.customFields &&
                                    member.customFields.wpUserID
                                ) {
                                    drawerStore().openDrawer({
                                        node: <TeamMember />,
                                    })
                                    setOverride(
                                        member.customFields?.wpUserID,
                                        false
                                    )
                                }
                            }}
                        >
                            <Stack
                                width={'100%'}
                                direction={'row'}
                                alignItems={'center'}
                                spacing={'8px'}
                            >
                                <MemberProfilePic
                                    rcUser={member}
                                    sideLength={36}
                                />
                                <Stack gap={'4px'}>
                                    <Typography
                                        variant="bodyBold"
                                        overflow={'hidden'}
                                        textOverflow={'ellipsis'}
                                        color={ColoursObj.core.primary}
                                    >
                                        {member.name ?? member.username}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack
                                display="flex"
                                justifyContent={'center'}
                                paddingLeft={'16px'}
                            >
                                {member.customFields &&
                                    member.customFields.wpUserID && (
                                        <Icon name="Chevron_Right" />
                                    )}
                            </Stack>
                        </Stack>
                    )
                })
            } else {
                return <div />
            }
        },
        [members, members?.value, api]
    )

    return (
        <NavigationView
            navigationBarTitle={
                <Typography variant="mobileH3">
                    {api?.value?.roomType === 'c'
                        ? 'Group Members'
                        : 'Chat Members'}
                </Typography>
            }
            backButtonAction={() => {
                safeSignalSet(chatView, 'chatInfo')
            }}
            usePageTransition
        >
            {returnMembersList()}
        </NavigationView>
    )
}
